export default __webpack_public_path__ + "static/media/restore.77a98a08.svg";